<!--eslint-disable-->
<template>
    <el-container>
        <el-header class="header" style="height:100px">
            <span>Data de referência: </span>
            <el-date-picker class="date-picker" v-model="chosenDate" type="date" format="dd/MM/yyyy" @change="updateFilesForRefDate"></el-date-picker>
            <el-button class="download-button" @click="gerarConsolidado" type="primary">Gerar consolidado</el-button>
            <p style="font-size:15px"> Emails enviados para: <b>movimentacoes@mail.leblonfund.com.br</b> </p>
            <el-dialog :visible.sync="dialogAttachmentVisible">
                <template slot="title">
                    <span class="main-title"> {{ attachmentView.subject }} </span></br>
                    <div class="big-content"> 
                        <span class="title-detail"> {{ attachmentView.name }} </span>
                    </div>
                </template>
                <div class="big-content">
                    <span v-for="content in attachmentView.content"> {{ content }} </br></span>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogAttachmentVisible = false">Fechar</el-button>
                    <el-button type="primary" @click="copyToClipboard(attachmentView.attachment)">Copiar</el-button>
                </span>
            </el-dialog>
        </el-header>
        <el-main class="main">
            <el-table
                class="table-principal"
                v-loading="loading"
                :data="tableData"
                border
                size="mini"
                width="50%"
                stripe>
                <template slot="empty">
                    <span>Os anexos recebidos em movimentacoes@mail.leblonfund.com.br aparecem aqui.</span>
                </template>
                <el-table-column
                    type="index"
                    width="35">
                </el-table-column>
                <el-table-column
                    prop="status"
                    width="35">
                    <template slot="header">
                        <el-checkbox @change="checkAllChange"></el-checkbox>
                    </template>
                    <template slot-scope="scope">
                        <el-checkbox v-model="scope.row.status"></el-checkbox>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="subject"
                    label="Assunto"
                    min-width="40">
                    <template slot-scope="scope">
                        <div class="big-content">
                            <span @click="visualizarAttachment(scope)">{{ scope.row.subject }}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="sender"
                    label="Remetente"
                    min-width="20">
                    <template slot-scope="scope">
                        <div class="big-content">
                            <span @click="visualizarAttachment(scope)">{{ scope.row.sender }}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="attachment_name"
                    label="Nome do Anexo"
                    min-width="40">
                    <template slot-scope="scope">
                        <div class="big-content">
                            <span @click="visualizarAttachment(scope)">{{ scope.row.attachment_name.slice(1, scope.row.attachment_name.length - 1) }}</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </el-main>
    </el-container>
</template>

<script>
/* eslint-disable */
import firebase from 'firebase/app'
import fb from '@/services/firebaseConfig'
import NewEditableColumn from '@/components/NewEditableColumn.vue'
import format from 'xml-formatter'
import regex from '@/services/regex'

const db = fb.db

export default {
    data() {
        return {
            loading: true,
            refDate: null,
            chosenDate: new Date(),
            table: null,
            dialogVisible: false,
            checkAll: false,
            dialogAttachmentVisible: false,
            attachmentView: {
                subject: '',
                name: '',
                content: [],
                attachment: ''
            },
            movFile: {
                name: '',
                content: []
            },
            movFilesTable: [],
            file: Object
        }
    },
    components: {
        NewEditableColumn
    },
    methods: {
        async updateFilesForRefDate() {
            db.collection('distAttachments')
                .where('timestamp', '<=', this.fimDia())
                .where('timestamp', '>=', this.inicioDia())
                .orderBy('timestamp', 'desc')
                .onSnapshot(
                    q => {
                        let auxTable = []
                        let date;
                        q.forEach(doc => {
                            date = doc.data().timestamp
                            auxTable.push({
                                status: false,
                                timestamp: new Date(doc.data().timestamp.seconds * 1000).toLocaleDateString("pt-BR"),
                                subject: doc.data().subject,
                                sender: doc.data().sender,
                                attachment_name: doc.data().attachment_name,
                                attachment: doc.data().attachment,
                                id: doc.id
                            })
                        })
                        this.table = auxTable
                        this.refDate = date
                        this.chosenDate = new Date(date.seconds * 1000)
                })
        },
        checkAllChange() {
            this.table.forEach(row => {
                row.status = !this.checkAll
            })
            this.checkAll = !this.checkAll
        },
        async gerarConsolidado() {
            
            // Pegar do banco o cadastro de cotistas nas distribuidoras
            let cadastroDistribuidoras
            let getCadastroDistribuidoras = firebase.functions().httpsCallable('getXmlNewClientTemplate')
            try {
                cadastroDistribuidoras = (await getCadastroDistribuidoras()).data.result
                console.log(cadastroDistribuidoras)
            } catch (err) {
                this.$root.$emit('showError', err, 'error')
            }
            
            // Processar emails selecionados pegando dados dos anexos e salvando cada linha em um objeto
            let clients = []
            let movFilesClients = []
            
            this.table.forEach(doc => {
                if (doc.status == true) {
                                        
                    let rows = doc.attachment.split('\n')
                    let headersRaw = rows[0].split(';')
                    let headers = headersRaw.map(header => {
                        if (header == "ORDEM_ADM") return "ORDEM ADM"
                        if (header == "CPF_CNPJ") return "CNPJ BTG"
                        if (header == "RESULTADO ") return "RESULTADO"
                        return header
                    })
                    
                    rows.forEach( (row, index) => {
                        let client = {}

                        if (index != 0) { // Pular primeira linha pois é a linha dos headers
                            if (!(row == null || row.trim() === '')) { // Pular linhas vazias
                                let values = row.split(';')

                                for (let i = 0; i < headers.length; i++) {
                                    let value = values[i] || ""
                                    if (headers[i] == "CNPJ BTG") {
                                        if (values[i].length <= 14 ) {
                                            value = values[i].replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5")
                                        }
                                    }
                                    client[headers[i]] = value.toString()
                                }
                                movFilesClients.push(client) // movFilesClients contém todos os dados do cliente vindos do arquvio anexo
                                clients.push({ // clients contém apenas o nome do cliente e o cnpj distribuidor, que é o que eu preciso para verificação de erros
                                    CNPJDistribuidor: client["CNPJ BTG"].replace(/\.|-|\//g,''),
                                    nome: client["NOME"]
                                })
                            }
                        }
                    })
                }
            })
            
            // Gerar um erro caso nenhum email tenha sido selecionado (ou os selecionados não tenham nenhuma movimentação)
            let clientsUnique = [... new Set(clients)]
            if (clientsUnique.length == 0) {
                this.$root.$emit('showError', 'Nenhum e-mail selecionado.', 'error')
                return
            }
            
            // Gerar erro caso alguma distribuidora nos arquivo não esteja no cadastro
            let distributorsNotFound = []
            clientsUnique.filter(client => {
                let distributorMatch = cadastroDistribuidoras.filter(cadastro => {
                    return client.CNPJDistribuidor == cadastro.CNPJDistribuidor
                })
                if (distributorMatch.length == 0) distributorsNotFound.push(client.CNPJDistribuidor)
            })
            let distributorNotFoundUnique = [... new Set(distributorsNotFound)]
            if (distributorNotFoundUnique.length > 0) {
                let errorMsg = "Não foram encontrados o(s) distribuidor(es): " + distributorNotFoundUnique.join(', ')
                this.$root.$emit('showError', errorMsg, 'error')
                return
            }
            
            // Gerar arquivo consolidado
            let finalFileHeaders = ["ID", "CODIGO", "NOME", "PRODUTO", "TIPO_MOV", "COTAS", "VALOR", "NUM_NOTA", "FORMA", "NUMERO_BANCO", 
                "NUMERO_AGENCIA", "NUMERO_CONTA", "DIGITO_VERIFICADOR", "TIPO_CONTA", "ORDEM ADM", "PGTO_PENALTYFEE", "DIAS_PENALTYFEE", 
                "PRODUTO_DESTINO", "ORDEM_ORIGEM", "NUM_ORDEM", "USAR_LIMITES_DIFERENCIADOS", "CNPJ BTG", "RESULTADO"]
            let file = finalFileHeaders.join(';') + '\n'
            movFilesClients.map(client => {
                finalFileHeaders.map(header => {
                    file += `${client[header] ? client[header] : ''};`
                })
                file = file.slice(0, -1)
                file += '\n'
            })
            file = file.slice(0, -1)
            
            try {
                let encodedUri = encodeURI(file)
                let link = document.createElement("a")
                link.setAttribute("href", "data:text;charset=utf-8,%EF%BB%BF" + encodedUri)
                link.setAttribute("download", 'LEBLON EQUITIES_BNY MELLON SERVIÇOS.txt')
                document.body.appendChild(link)
                link.click()
            } catch (err) {
                this.$root.$emit('showError', err, 'error')
            }
            
        },
        visualizarAttachment(scope) {
            this.attachmentView.content = []
            this.attachmentView.attachment = scope.row["attachment"]
            this.attachmentView.subject = scope.row["subject"]
            this.attachmentView.name = scope.row["attachment_name"].slice(1, scope.row["attachment_name"].length-1)
            let rows = scope.row["attachment"].split('\n')
            for (let i=0; i < Math.min(5, rows.length); i++) {
                this.attachmentView.content.push(rows[i])
            }
            this.dialogAttachmentVisible = true
        },
        fimDia() {
            let now = new Date(this.chosenDate)
            return new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59)
        },
        inicioDia() {
            let now = new Date(this.chosenDate)
            return new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0)
        },
        timestampToISOString(timestamp) {
            return new Date(timestamp.seconds * 1000).toISOString().split('T')[0]
        },
        copyToClipboard(textToCopy) {
            let textarea = document.createElement('textarea')
            textarea.value = textToCopy
            document.body.appendChild(textarea)
            textarea.select()
            document.execCommand('copy')
            document.body.removeChild(textarea)
        }
    },
    computed: {
        tableData() {
            return this.table
        }
    },
    async created() {
        this.loading = true
        db.collection('distAttachments')
            .where('timestamp', '<=', this.fimDia())
            .where('timestamp', '>=', this.inicioDia())
            .orderBy('timestamp', 'desc')
            .onSnapshot(
                q => {
                    let auxTable = []
                    let date;
                    q.forEach(doc => {
                        date = doc.data().timestamp
                        auxTable.push({
                            status: false,
                            timestamp: new Date(doc.data().timestamp.seconds * 1000).toLocaleDateString("pt-BR"),
                            subject: doc.data().subject,
                            sender: doc.data().sender,
                            attachment_name: doc.data().attachment_name,
                            attachment: doc.data().attachment,
                            id: doc.id
                        })
                    })
                    this.table = auxTable
                    this.refDate = date
                    this.chosenDate = new Date(date.seconds * 1000)
            })
    
        this.loading = false
    },
}
</script>

<style scoped>
.el-input .el-input__inner {
    color: red;
}
.big-content {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.download-button {
    margin-left: 30px;
    margin-top: 10px;
    margin-bottom: 10px;
}
.distributor {
    width: 1500px;
}
.el-dialog .main-title {
    font-weight: bold;
    font-size: 22px;
}
.el-dialog .title-detail {
    font-style: italic;
    font-size: 18px;
}
.date-picker >>> input{
    color: red;
}
.el-header.header {
    width: 1485px;
    font-family: Calibri;
    color: #606266;
    padding: 0 10px;
    font-size: 20px;
    margin-bottom: 5px;
}
.el-table .cell {
    word-wrap: break-word;
}
.el-table .cell-size {
    padding: 1px 0;
    font-family: Calibri;
}
.el-main.main {
    padding: 0 10px;
}
hr { 
    display: block;
    margin-top: 0.5em;
    margin-bottom: 0.5em;
    margin-left: auto;
    margin-right: auto;
    border-style: inset;
    border-width: 1px;
}
</style>